import {
  Container,
  classNames,
  FlexColumn,
  Media,
  Portal,
  Separator,
} from "@opensea/ui-kit"
import type React from "react"
import { useHeroHeader } from "./HeroHeaderProvider"
import { headerViewFullVariants } from "./hero-header-view-full-variants"
import { headerViewOverflowClassNames } from "./variants"

type Props = {
  info: React.ReactNode
  description: React.ReactNode
  stats: React.ReactNode
  metadataChips: React.ReactNode
  showMetadataChipsOnLarge?: boolean
  className?: string
}

export function HeroHeaderFullLayout({
  info,
  description,
  stats,
  metadataChips,
  showMetadataChipsOnLarge = true,
  className,
}: Props) {
  const { container, content } = headerViewFullVariants()
  const { container: containerElement } = useHeroHeader()

  return (
    <Container className={classNames(container(), className)}>
      <div className={content()}>
        <FlexColumn className="lg:grow">
          {info}
          <Media greaterThanOrEqual="lg">
            {showMetadataChipsOnLarge ? metadataChips : null}
            {description}
          </Media>
        </FlexColumn>
        <Media greaterThanOrEqual="lg">
          <div
            className={classNames(
              "mt-4 flex min-w-0 flex-col overflow-x-visible md:mt-0 lg:flex-row lg:justify-end",
              headerViewOverflowClassNames,
            )}
          >
            <div className="mt-6 gap-3">{stats}</div>
          </div>
        </Media>
        <Portal container={containerElement}>
          <Media lessThan="lg">
            <Media lessThan="md">{metadataChips}</Media>
            {description}
            <Separator className="my-4" />
            {stats}
          </Media>
        </Portal>
      </div>
    </Container>
  )
}
